import { BaseApiClient } from './base-client'
import {
  API_ROUTES,
  type OnboardingEventsResponse,
  type OnboardingPersonalizationResponse,
  type OnboardingStateResponse,
  type RecapResponse,
  type UpdateOnboardingDto,
} from '@super/shared-types'

interface Envelope<T> {
  data: T
}

class OnboardingApiClient extends BaseApiClient {
  async getState(): Promise<OnboardingStateResponse> {
    const response = await this.request<Envelope<OnboardingStateResponse>>(
      API_ROUTES.ONBOARDING.GET,
      { method: 'GET', credentials: 'include' },
    )
    return response.data
  }

  async patch(patch: UpdateOnboardingDto): Promise<OnboardingStateResponse> {
    const response = await this.request<Envelope<OnboardingStateResponse>>(
      API_ROUTES.ONBOARDING.UPDATE,
      {
        method: 'PATCH',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(patch),
      },
    )
    return response.data
  }

  async getRecap(): Promise<RecapResponse> {
    const response = await this.request<Envelope<RecapResponse>>(
      API_ROUTES.ONBOARDING.RECAP,
      { method: 'GET', credentials: 'include' },
    )
    return response.data
  }

  async getPersonalization(): Promise<OnboardingPersonalizationResponse> {
    const response = await this.request<
      Envelope<OnboardingPersonalizationResponse>
    >(API_ROUTES.ONBOARDING.PERSONALIZATION, {
      method: 'GET',
      credentials: 'include',
    })
    return response.data
  }

  async listEvents(
    opts: {
      limit?: number
      before?: string
    } = {},
  ): Promise<OnboardingEventsResponse> {
    const params = new URLSearchParams()
    if (opts.limit) params.set('limit', String(opts.limit))
    if (opts.before) params.set('before', opts.before)
    const query = params.toString() ? `?${params.toString()}` : ''
    const response = await this.request<Envelope<OnboardingEventsResponse>>(
      `${API_ROUTES.ONBOARDING.EVENTS}${query}`,
      { method: 'GET', credentials: 'include' },
    )
    return response.data
  }
}

export const onboardingClient = new OnboardingApiClient()
